import { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

// Production origin used for absolute og:url / canonical / image URLs.
const SITE_URL = 'https://brandscapitalgroup.com';
// TODO: provide a real 1200x630 share image at public/og-image.png
const OG_IMAGE = `${SITE_URL}/og-image.png`;

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Sets per-page, per-language <head> tags for this client-rendered SPA.
 * NOTE: JS-injected meta is weaker than server-rendered meta for SEO; the
 * static defaults in public/index.html cover non-JS crawlers.
 */
const Seo = ({ titleKey, descKey, path }) => {
  const { t, lang } = useLanguage();
  const title = t(titleKey);
  const description = t(descKey);
  const url = `${SITE_URL}${path}`;

  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;

    upsertMeta('name', 'description', description);

    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', 'Brands Capital Group');
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', OG_IMAGE);
    upsertMeta('property', 'og:locale', lang === 'fr' ? 'fr_FR' : 'en_US');

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', OG_IMAGE);

    upsertLink('canonical', url);
  }, [title, description, url, lang]);

  return null;
};

export default Seo;
